var render = function render(){var _vm=this,_c=_vm._self._c;return _c('f7-button',{staticClass:"button-pagenation",on:{"click":function($event){return _vm.$emit('click', $event)}}},[_c('svg-icon',{staticClass:"icon-pagenation",style:({ 'width': _vm.width }),attrs:{"icon":_vm.iconName}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }